import BackButton from "../../components/CustomButton/BackButton"
import CustomCard from "../../components/CustomCard/CustomCard"
import { Spin, Row, Col, Typography, Collapse, Image } from "antd"
import { useDispatch, useSelector } from 'react-redux'
import DealDetail from "../../components/Details/DealDetail"
import { GLOBAL_CONSTANTS } from "../../constants/constants"
import { getDisputeById } from "../../redux/slices/PaymentsSlice"
import { useParams } from 'react-router-dom'
import { useEffect, useState, useMemo } from 'react'
import { capitalizeWords, formatCurrency, disputeAgeCalculation } from '../../helpers/helpers'
import { formatPaymentDateTime } from './helpers'
import CustomTable from "../../components/CustomTable/CustomTable"
import { getDisputeCommentColumns, getDisputeRelTxnColumns } from "./Components/getPaymentColumns"
import ArrowDownIcon from "../../assets/icons/arrow-down-icon.svg"

const { Title, Text } = Typography

const DisputeDetails = () => {
    const dispatch = useDispatch();
    const { disputeId } = useParams();
    const { disputeDetails, disputeLoading } = useSelector((state) => state.payments);
    const [activeKey, setActiveKey] = useState(["1"])

    const panelStyle = {
        marginBottom: 24,
        borderRadius: 8,
        border: "1px solid #D8E4FD",
    };

    const commentsColumns = useMemo(
        () =>
            getDisputeCommentColumns(),
        []
    );

    const disRelColumns = useMemo(
        () =>
            getDisputeRelTxnColumns(),
        []
    );

    const collapseItems = [
        {
            key: '1',
            label: <Text strong>Comment History</Text>,
            children: <CustomTable
                rowKey="disputeCommentId"
                columns={commentsColumns}
                dataSource={disputeDetails?.disputeCommentsDetails || []}
                tableContainerStyle='dispute-comments-table'
            />,
            style: { ...panelStyle },
        },

    ];

    useEffect(() => {
        dispatch(getDisputeById(disputeId));
    }, [disputeId, dispatch]);

    return (
        <div className='payment-details-container'>
            <BackButton />
            <CustomCard className='payment-details-card'>
                <Spin spinning={disputeLoading}>
                    <Title level={4}>Dispute Details</Title>
                    <div className='details-container'>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} md={12}>
                                <div className='detail-col-container'>
                                    <DealDetail
                                        label="Transaction ID"
                                        value={disputeDetails?.transactionId || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Dispute ID"
                                        value={disputeDetails?.disputeId || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="UTR"
                                        value={disputeDetails?.utr || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Dispute Date"
                                        value={formatPaymentDateTime(disputeDetails?.disputeDate) || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Dispute age"
                                        value={disputeAgeCalculation(disputeDetails?.disputeDate) || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Dispute Priority"
                                        value={disputeDetails?.disputePriorityDesc || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Dispute Raised For"
                                        value={disputeDetails?.accHolderName || GLOBAL_CONSTANTS.NA}
                                    />
                                </div>
                            </Col>
                            <Col xs={24} md={12}>
                                <div className='detail-col-container'>
                                    <DealDetail
                                        label="Transaction Status"
                                        value={<Text className='txn-status'>{capitalizeWords(disputeDetails?.disputeStatusDesc)}</Text> || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Transaction Date"
                                        value={formatPaymentDateTime(disputeDetails?.TxnDetail?.transactionDate) || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Transaction Amount"
                                        value={formatCurrency(disputeDetails?.TxnDetail?.amount) || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Dispute Type"
                                        value={disputeDetails?.disputeTypeDesc || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Dispute Amount"
                                        value={formatCurrency(disputeDetails?.disputeAmount) || GLOBAL_CONSTANTS.NA}
                                    />
                                    <DealDetail
                                        label="Dispute Created By"
                                        value={disputeDetails?.createdByName || GLOBAL_CONSTANTS.NA}
                                    />
                                </div>
                            </Col>
                            <Col xs={24}>
                                <div className='detail-col-container'>
                                    <DealDetail
                                        label="Dispute Reason"
                                        value={disputeDetails?.disputeReasonDesc || GLOBAL_CONSTANTS.NA}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Collapse
                        bordered={false}
                        activeKey={activeKey}
                        onChange={(key) => setActiveKey(key)}
                        expandIcon={({ isActive }) => (
                            <Image
                                src={ArrowDownIcon}
                                alt='Arrow'
                                preview={false}
                                style={{
                                    transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            />
                        )}
                        expandIconPosition='end'
                        style={{ width: '100%', marginTop: 20 }}
                        items={collapseItems}
                    />
                    <Title level={4} style={{ marginTop: 20 }}>Dispute Related Transactions</Title>
                    <CustomTable
                        rowKey="transactionId"
                        columns={disRelColumns}
                        dataSource={disputeDetails?.refTxnDetails || []}
                        tableContainerStyle='dispute-table'
                    />
                </Spin>
            </CustomCard>
        </div>
    )
}

export default DisputeDetails